// import Trustbadge from "./TrustedShopsWidget";
// import { Link } from "react-router-dom";
// import { useEffect } from "react";
// import { useTranslate } from '../hooks/useTranslate';

// 	function Footer({ data = [], categories = [], site_settings = [] }) {
// const __ = useTranslate();
// useEffect(() => {
//     if (site_settings?.cookies_enabled != 1) return;
    
//     if (process.env.NODE_ENV !== 'production') {
//       return;
//     }

//     const scriptId = "cookieyes";
//     if (!document.getElementById(scriptId)) {
//       const script = document.createElement("script");
//       script.id = scriptId;
//       script.type = "text/javascript";
//       script.src = "https://cdn-cookieyes.com/client_data/f6e55087aa639a28d642082db4e3efc6/script.js";
//       script.async = true;
//       document.head.appendChild(script);
//     }
//   }, [site_settings?.cookies_enabled]);
//     return (
// 			<footer className="footer">
//       <div className="container">
//         <div className="top-footer">
//           <div className="row justify-content-between gy-3 gy-lg-0">
//             <div className="col-md-3">
//               <h4>{site_settings?.footer_heading_1}</h4>
//               <div className="footer-links">
//                 <ul>
//                     {(data || []).map((item) => (
//                   <li key={item.id_custom_menu}><Link to={item.link} className="link">{item.title}</Link></li>

//   ))}
//                 </ul>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <h4>{site_settings?.footer_heading_2}</h4>
//               <div className="footer-links">
//                 <ul>
// {(categories || []).slice(0, 10).map((category) => (
//   <li key={category.id_category}>
//     <Link to={`/${category.link_rewrite}`} className="link">
//       {category.name}
//     </Link>
//   </li>
// ))}
//                 </ul>
//               </div>
//             </div>
//             <div className="col-md-2">
//               <h4>{site_settings?.footer_heading_3}</h4>
//               <div className="footer-links">
//                 <ul>
//                   <li>{__("Amsterdam")}</li>
//                   {site_settings.working_hours && (
//                   <li>{site_settings.working_hours}</li>
//                   )}
//                 </ul>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <h4>{site_settings?.footer_heading_4}</h4>
//               <div className="footer-links">
//                 <ul>
//                   <li><a href="javascript:;" className="link">{__("Amsterdam store")}</a></li>
//                   {site_settings.address && (
//                   <li><a href="javascript:;" className="link">{site_settings.address}</a></li>
//                   )}
//                   {site_settings.phone && (
//                   <li><a href={`tel:${site_settings?.phone}`} className="link">{site_settings.phone}</a></li>
//                   )}
//                   {site_settings.email && (
//                   <li><a href={`mailto:${site_settings?.email}`} className="link">{site_settings.email}</a></li>
//                   )}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="bottom-footer">
//           <div className="row justify-content-between align-items-center gy-3 gy-lg-0">
//             <div className="col-md-7">
//               <div className="bottom-main d-flex align-items-center">
//                 <div className="footer-badge">
//                   <ul className="d-flex align-items-center gap-3">
//                     {site_settings.card_image_1 && (
//                     <li><img src={site_settings.card_image_1} alt="*" className="w-100" /></li>
//                     )}
//                     {site_settings.card_image_2 && (
//                     <li><img src={site_settings.card_image_2} alt="*" className="w-100" /></li>
//                     )}
//                     {site_settings.card_image_3 && (
//                     <li><img src={site_settings.card_image_3} alt="*" className="w-100" /></li>
//                     )}
//                     {site_settings.card_image_4 && (
//                     <li><img src={site_settings.card_image_4} alt="*" className="w-100" /></li>
//                     )}
//                     {site_settings.card_image_5 && (
//                     <li><img src={site_settings.card_image_5} alt="*" className="w-100" /></li>
//                     )}
//                     {site_settings.card_image_6 && (
//                     <li><img src={site_settings.card_image_6} alt="*" className="w-100" /></li>
//                     )}
//                     {site_settings.card_image_7 && (
//                     <li><img src={site_settings.card_image_7} alt="*" className="w-100" /></li>
//                     )}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//             <div className="col-md-5">
//               <div className="news-main d-flex align-items-center justify-lg-content-end flex-wrap gap-xxl-5 gap-3">
//                 <div className="newsletter-form d-flex align-items-center">
//                   <h5>{__("Newsletter")}</h5>
//                   <form>
//                     <div className="form-group mb-0 position-relative d-flex">
//                       <input
//                         type="email"
//                         name="email"
//                         placeholder={__("Enter your email")}
//                         required
//                         className="form-control"
//                       />
//                       <button className="submit btn-mail">
//                         <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
//                           <rect width="32" height="32" rx="16" fill="#1C1C1C" />
//                           <path d="M14 20L18 16L14 12" stroke="white" strokeLinecap="square" />
//                         </svg>
//                       </button>
//                     </div>
//                   </form>
//                 </div>

//                 <div className="footer-icons">
//                   <ul className="d-flex align-items-center gap-4">
//                     {site_settings.facebook && (

//                     <li>
//                       <a href={site_settings.facebook} className="icons">
//                         <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
// 									<path d="M11.1263 15.5658H8.1605C7.68155 15.5658 7.53418 15.3816 7.53418 14.9395V11.3106C7.53418 10.8316 7.71839 10.6474 8.1605 10.6474H11.1263V8.01321C11.0894 6.85268 11.3658 5.67374 11.9368 4.62374C12.5447 3.57374 13.5026 2.80005 14.6079 2.41321C15.3631 2.13689 16.1 2.02637 16.8921 2.02637H19.821C20.2447 2.02637 20.4289 2.21058 20.4289 2.63426V6.04216C20.4289 6.46584 20.2447 6.65005 19.821 6.65005C19.0105 6.65005 18.2 6.65005 17.3894 6.68689C16.5789 6.72374 16.1552 7.07374 16.1552 7.9211C16.1184 8.82374 16.1552 9.68952 16.1552 10.6106H19.6C20.0789 10.6106 20.2631 10.7948 20.2631 11.2737V14.9027C20.2631 15.3816 20.1158 15.5658 19.6 15.5658H16.1921V25.3106C16.1921 25.8264 16.0079 25.9922 15.5105 25.9922H11.771C11.3289 25.9922 11.1447 25.8079 11.1447 25.3658L11.1263 15.5658Z" fill="#1C1C1C"></path>
// 								</svg>
//                       </a>
//                     </li>
//                     )}
// {site_settings.instagram && (
//                     <li>
//                       <a href={site_settings.instagram} className="icons">
//                         <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
// 								<path d="M19.379 2.02637H8.6211C4.95531 2.02637 2.02637 4.95531 2.02637 8.6211V19.3974C2.02637 23.0448 4.95531 25.9922 8.6211 25.9922H19.3974C23.0448 25.9922 25.9922 23.0632 25.9922 19.3974V8.6211C25.9737 4.95531 23.0448 2.02637 19.379 2.02637ZM23.8737 18.4395C23.8737 21.4237 21.4422 23.8922 18.4211 23.8922H9.579C6.59479 23.8922 4.12637 21.4606 4.12637 18.4395V9.579C4.12637 6.59479 6.55795 4.12637 9.579 4.12637H18.4764C21.4606 4.12637 23.929 6.55795 23.929 9.579V18.4395H23.8737Z" fill="#1C1C1C"></path>
// 								<path d="M18.3658 9.68949L18.3106 9.63423L18.2553 9.57897C17.1132 8.43686 15.5842 7.81055 14 7.81055C10.6106 7.82897 7.86583 10.6105 7.88425 14C7.88425 15.6395 8.54741 17.2053 9.68951 18.3658C10.8316 19.5263 12.379 20.1711 14 20.1711C17.4079 20.1158 20.1342 17.2605 20.079 13.8158C20.0421 12.2869 19.4527 10.7948 18.3658 9.68949ZM14 18.0711C11.7527 18.1079 9.92898 16.3027 9.89214 14.0553C9.8553 11.8079 11.6606 9.98423 13.9079 9.94739C16.1553 9.91055 17.979 11.7158 18.0158 13.9632V14.0184C18.0158 16.2105 16.2106 18.0342 14 18.0711ZM21.9027 7.53423C21.9027 8.34476 21.2764 9.00792 20.4658 9.00792C20.079 9.00792 19.7106 8.86055 19.4527 8.58423C18.8816 8.01318 18.8816 7.05528 19.4895 6.48423C19.7658 6.20792 20.1158 6.06055 20.5027 6.06055C20.8342 6.06055 21.1658 6.18949 21.4237 6.39213L21.4606 6.42897C21.5158 6.46581 21.5527 6.52107 21.5895 6.55791L21.6264 6.59476C21.7737 6.85265 21.9027 7.18423 21.9027 7.53423Z" fill="#1C1C1C"></path>
// 							</svg>
//                       </a>
//                     </li>
//                     )}
// {site_settings.pinterest && (
//                     <li>
//                       <a href={site_settings.pinterest} className="icons">
//                         <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
// 							<path d="M25.9737 14.35C26.1579 7.73688 20.9448 2.22899 14.3685 2.04478C7.75529 1.84214 2.2474 7.0553 2.02635 13.6685C1.87898 18.3658 4.53161 22.7132 8.75003 24.7764C8.93424 24.8685 9.10003 24.7764 9.19214 24.629C9.22898 24.5737 9.22898 24.5369 9.22898 24.4816C9.19214 23.7264 9.22898 22.9527 9.37635 22.2343C9.52372 21.5711 10.1316 19.0658 10.5185 17.4079C10.7027 16.5974 10.7211 15.7685 10.5737 14.9579C10.5185 14.6632 10.4816 14.3685 10.4816 14.0369C10.4816 12.2685 11.4948 10.9606 12.7842 10.9606C13.8527 10.9606 14.4053 11.7711 14.4053 12.7474C14.4053 13.8527 13.7237 15.4737 13.3553 17.0027C13.1158 17.9974 13.7053 19.0106 14.7 19.25C14.8842 19.3053 15.05 19.3053 15.2342 19.3053C17.5 19.3053 19.25 16.9106 19.25 13.4658C19.25 10.4079 17.0579 8.28951 13.9263 8.28951C10.2974 8.28951 8.17898 11.0158 8.17898 13.8158C8.17898 14.8658 8.51056 15.879 9.13687 16.7264C9.22898 16.8185 9.2474 16.9658 9.22898 17.0764C9.13687 17.4632 8.93424 18.329 8.87898 18.5132C8.82372 18.7527 8.69477 18.7895 8.4553 18.6974C6.87108 17.8869 5.85793 15.5474 5.85793 13.7053C5.85793 9.68951 8.76845 6.02372 14.2579 6.02372C18.679 6.02372 22.1053 9.17372 22.1053 13.3553C22.1053 17.7579 19.3606 21.2764 15.4921 21.2764C14.5711 21.2764 13.6316 20.9264 12.95 20.2816C12.8395 20.1711 12.6185 20.1711 12.5079 20.2816C12.4711 20.3185 12.4527 20.3737 12.4158 20.429C12.2132 21.1843 11.8816 22.4369 11.7895 22.8237C11.55 23.6343 11.2185 24.3711 10.7948 25.1264C10.7027 25.2737 10.7579 25.4764 10.9421 25.5685C10.979 25.5685 10.9974 25.6053 11.0342 25.6053C12.029 25.8448 13.0606 25.9921 14.0921 25.9553C20.4106 25.9 25.7895 20.6316 25.9737 14.35Z" fill="#1C1C1C"></path>
// 						</svg>
//                       </a>
//                     </li>
// )}
//                   </ul>
//                 </div>

//               </div>
//             </div>

//           </div>
//         </div>
//         {site_settings?.trustedshop_enabled == 1 && (
//           <Trustbadge shopId="X8BEC543A1A07D4214B91255D1AC72EF6" />
//         )}
//       </div>
//     </footer>
// 		);
// 	}

// 	export default Footer;

import Trustbadge from "./TrustedShopsWidget";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useTranslate } from '../hooks/useTranslate';
import { FullLinkLang, LinkLang } from "./LinkLang";
import { base_url } from "./config";

function Footer({ data = [], agc_footer_menu = [], categories = [], site_settings = [] }) {
  const __ = useTranslate();
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterWebsite, setNewsletterWebsite] = useState("");
  const [newsletterStatus, setNewsletterStatus] = useState({ type: "", message: "" });
  const [newsletterSubmitting, setNewsletterSubmitting] = useState(false);

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();

    if (newsletterSubmitting) return;

    // Silently accept bot submissions without contacting the subscription API.
    if (newsletterWebsite.trim()) {
      setNewsletterStatus({
        type: "success",
        message: __("Thank you for subscribing!"),
      });
      setNewsletterEmail("");
      setNewsletterWebsite("");
      return;
    }

    const mailchimpConfig = site_settings?.mailchimp_config;
    if (mailchimpConfig && (
      !mailchimpConfig.enabled ||
      !mailchimpConfig.connected ||
      !mailchimpConfig.store_synced ||
      !mailchimpConfig.newsletter_sync_enabled
    )) {
      setNewsletterStatus({
        type: "error",
        message: __("Newsletter subscription is currently unavailable."),
      });
      return;
    }

    setNewsletterSubmitting(true);
    setNewsletterStatus({ type: "", message: "" });

    try {
      const body = new URLSearchParams({
        email: newsletterEmail.trim(),
        action: "0",
        submitNewsletter: "1",
      });

      const response = await fetch(
        `${base_url}ps_emailsubscription/subscription?ajax=1`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          body: body.toString(),
        }
      );

      if (!response.ok) {
        throw new Error(`Newsletter request failed with status ${response.status}`);
      }

      const result = await response.json();
      const hasError = Boolean(result?.nw_error);

      setNewsletterStatus({
        type: hasError ? "error" : "success",
        message: result?.msg || (
          hasError
            ? __("Unable to subscribe. Please try again.")
            : __("Thank you for subscribing!")
        ),
      });

      if (!hasError) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'newsletter_signup',
          form_location: 'footer',
        });
        setNewsletterEmail("");
      }
    } catch (error) {
      setNewsletterStatus({
        type: "error",
        message: __("Unable to subscribe. Please try again."),
      });
    } finally {
      setNewsletterSubmitting(false);
    }
  };
  
  // Use the new agc_footer_menu if available, fallback to old data
  const footerMenu = agc_footer_menu?.length > 0 ? agc_footer_menu : data;
  
  // Separate root level items
  const rootMenuItems = footerMenu.filter(item => item.parent_id === 0);
  
  
  
  // useEffect(() => {
  //   if (site_settings?.cookies_enabled != 1) return;
    
  //   if (process.env.NODE_ENV !== 'production') {
  //     return;
  //   }

  //   const scriptId = "cookieyes";
  //   if (!document.getElementById(scriptId)) {
  //     const script = document.createElement("script");
  //     script.id = scriptId;
  //     script.type = "text/javascript";
  //     script.src = "https://cdn-cookieyes.com/client_data/f6e55087aa639a28d642082db4e3efc6/script.js";
  //     script.async = true;
  //     document.head.appendChild(script);
  //   }
  // }, [site_settings?.cookies_enabled]);
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="top-footer">
          <div className="row justify-content-between gy-3 gy-lg-0">
            <div className="col-md-3">
              <h4>{site_settings?.footer_heading_1}</h4>
              <div className="footer-links">
                <ul>
                  {rootMenuItems.map((item) => {
                    const isFullUrl_child = /^https?:\/\//i.test(item.link);
                              let link = LinkLang(item.link)
                              if (isFullUrl_child) {
                                  link = FullLinkLang(item.link)
                              } else {
                                  link = LinkLang(item.link)
                              }
                    return(
                    <li key={item.id_menu}>
                      <Link to={link} className="link">{item.title}</Link>
                    </li>
                  )})}
                </ul>
              </div>
            </div>
            <div className="col-md-3">
              <h4>{site_settings?.footer_heading_2}</h4>
              <div className="footer-links">
                <ul>
                  {(categories || []).slice(0, 10).map((category) => (
                    <li key={category.id_category}>
                      <Link to={LinkLang(`/${category.link_rewrite}`)} className="link">
                        {category.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-md-2">
              <h4>{site_settings?.footer_heading_3}</h4>
              <div className="footer-links">
                <ul>
                  <li>{__("Amsterdam")}</li>
                  {site_settings.working_hours && (
                    <li>{site_settings.working_hours}</li>
                  )}
                </ul>
              </div>
            </div>
            <div className="col-md-3">
              <h4>{site_settings?.footer_heading_4}</h4>
              <div className="footer-links">
                <ul>
                  <li><a href="javascript:;" className="link">{__("Amsterdam store")}</a></li>
                  {site_settings.address && (
                    <li><a href="javascript:;" className="link" dangerouslySetInnerHTML={{__html:site_settings.address}}></a></li>
                  )}
                  {site_settings.phone && (
                    <li><a href={`tel:${site_settings?.phone}`} className="link footer-contact-link">{site_settings.phone}</a></li>
                  )}
                  {site_settings.email && (
                    <li><a href={`mailto:${site_settings?.email}`} className="link footer-contact-link">{site_settings.email}</a></li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-footer">
          <div className="row justify-content-between align-items-center gy-3 gy-lg-0">
            <div className="col-md-7">
              <div className="bottom-main d-flex align-items-center">
                <div className="footer-badge">
                  <ul className="d-flex align-items-center gap-3">
                    {site_settings.card_image_1 && (
                      <li><img src={site_settings.card_image_1} width={59} height={30} alt="*" className="w-100" /></li>
                    )}
                    {site_settings.card_image_2 && (
                      <li><img src={site_settings.card_image_2} width={59} height={30} alt="*" className="w-100" /></li>
                    )}
                    {site_settings.card_image_3 && (
                      <li><img src={site_settings.card_image_3} width={59} height={30} alt="*" className="w-100" /></li>
                    )}
                    {site_settings.card_image_4 && (
                      <li><img src={site_settings.card_image_4} width={59} height={30} alt="*" className="w-100" /></li>
                    )}
                    {site_settings.card_image_5 && (
                      <li><img src={site_settings.card_image_5} width={59} height={30} alt="*" className="w-100" /></li>
                    )}
                    {site_settings.card_image_6 && (
                      <li><img src={site_settings.card_image_6} width={59} height={30} alt="*" className="w-100" /></li>
                    )}
                    {site_settings.card_image_7 && (
                      <li><img src={site_settings.card_image_7} width={59} height={30} alt="*" className="w-100" /></li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="news-main d-flex align-items-center justify-lg-content-end flex-wrap gap-xxl-5 gap-3">
                <div className="newsletter-form d-flex align-items-center">
                  <h5>{__("Newsletter")}</h5>
                  <form onSubmit={handleNewsletterSubmit}>
                    <div className="newsletter-honeypot" aria-hidden="true">
                      <label htmlFor="newsletter-website">Website</label>
                      <input
                        id="newsletter-website"
                        type="text"
                        name="website"
                        value={newsletterWebsite}
                        onChange={(event) => setNewsletterWebsite(event.target.value)}
                        tabIndex={-1}
                        autoComplete="off"
                      />
                    </div>
                    <div className="form-group mb-0 position-relative d-flex">
                      <input
                        type="email"
                        name="email"
                        value={newsletterEmail}
                        onChange={(event) => setNewsletterEmail(event.target.value)}
                        placeholder={__("Enter your email")}
                       aria-label={__("Email address for newsletter")}
                        required
                        disabled={newsletterSubmitting}
                        className="form-control"
                      />
                      <button
                        type="submit"
                        className="submit btn-mail"
                        disabled={newsletterSubmitting}
                        aria-label={__("Subscribe to newsletter")}
                      >
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                          <rect width="32" height="32" rx="16" fill="#1C1C1C" />
                          <path d="M14 20L18 16L14 12" stroke="white" strokeLinecap="square" />
                        </svg>
                      </button>
                    </div>
                    {newsletterStatus.message && (
                      <small
                        className={`d-block mt-1 ${newsletterStatus.type === "success" ? "text-success" : "text-danger"}`}
                        role="status"
                        aria-live="polite"
                      >
                        {newsletterStatus.message}
                      </small>
                    )}
                  </form>
                </div>

                <div className="footer-icons">
                  <ul className="d-flex align-items-center gap-4">
                    {site_settings.facebook && (
                      <li>
                        <a href={site_settings.facebook} className="icons" aria-label={__("SuperGallery on Facebook")}>
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <path d="M11.1263 15.5658H8.1605C7.68155 15.5658 7.53418 15.3816 7.53418 14.9395V11.3106C7.53418 10.8316 7.71839 10.6474 8.1605 10.6474H11.1263V8.01321C11.0894 6.85268 11.3658 5.67374 11.9368 4.62374C12.5447 3.57374 13.5026 2.80005 14.6079 2.41321C15.3631 2.13689 16.1 2.02637 16.8921 2.02637H19.821C20.2447 2.02637 20.4289 2.21058 20.4289 2.63426V6.04216C20.4289 6.46584 20.2447 6.65005 19.821 6.65005C19.0105 6.65005 18.2 6.65005 17.3894 6.68689C16.5789 6.72374 16.1552 7.07374 16.1552 7.9211C16.1184 8.82374 16.1552 9.68952 16.1552 10.6106H19.6C20.0789 10.6106 20.2631 10.7948 20.2631 11.2737V14.9027C20.2631 15.3816 20.1158 15.5658 19.6 15.5658H16.1921V25.3106C16.1921 25.8264 16.0079 25.9922 15.5105 25.9922H11.771C11.3289 25.9922 11.1447 25.8079 11.1447 25.3658L11.1263 15.5658Z" fill="#1C1C1C"/>
                          </svg>
                        </a>
                      </li>
                    )}
                    {site_settings.instagram && (
                      <li>
                        <a href={site_settings.instagram} className="icons" aria-label={__("SuperGallery on Instagram")}>
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <path d="M19.379 2.02637H8.6211C4.95531 2.02637 2.02637 4.95531 2.02637 8.6211V19.3974C2.02637 23.0448 4.95531 25.9922 8.6211 25.9922H19.3974C23.0448 25.9922 25.9922 23.0632 25.9922 19.3974V8.6211C25.9737 4.95531 23.0448 2.02637 19.379 2.02637ZM23.8737 18.4395C23.8737 21.4237 21.4422 23.8922 18.4211 23.8922H9.579C6.59479 23.8922 4.12637 21.4606 4.12637 18.4395V9.579C4.12637 6.59479 6.55795 4.12637 9.579 4.12637H18.4764C21.4606 4.12637 23.929 6.55795 23.929 9.579V18.4395H23.8737Z" fill="#1C1C1C"/>
                            <path d="M18.3658 9.68949L18.3106 9.63423L18.2553 9.57897C17.1132 8.43686 15.5842 7.81055 14 7.81055C10.6106 7.82897 7.86583 10.6105 7.88425 14C7.88425 15.6395 8.54741 17.2053 9.68951 18.3658C10.8316 19.5263 12.379 20.1711 14 20.1711C17.4079 20.1158 20.1342 17.2605 20.079 13.8158C20.0421 12.2869 19.4527 10.7948 18.3658 9.68949ZM14 18.0711C11.7527 18.1079 9.92898 16.3027 9.89214 14.0553C9.8553 11.8079 11.6606 9.98423 13.9079 9.94739C16.1553 9.91055 17.979 11.7158 18.0158 13.9632V14.0184C18.0158 16.2105 16.2106 18.0342 14 18.0711ZM21.9027 7.53423C21.9027 8.34476 21.2764 9.00792 20.4658 9.00792C20.079 9.00792 19.7106 8.86055 19.4527 8.58423C18.8816 8.01318 18.8816 7.05528 19.4895 6.48423C19.7658 6.20792 20.1158 6.06055 20.5027 6.06055C20.8342 6.06055 21.1658 6.18949 21.4237 6.39213L21.4606 6.42897C21.5158 6.46581 21.5527 6.52107 21.5895 6.55791L21.6264 6.59476C21.7737 6.85265 21.9027 7.18423 21.9027 7.53423Z" fill="#1C1C1C"/>
                          </svg>
                        </a>
                      </li>
                    )}
                    {site_settings.pinterest && (
                      <li>
                        <a href={site_settings.pinterest} className="icons" aria-label={__("SuperGallery on Pinterest")}>
                          <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <path d="M25.9737 14.35C26.1579 7.73688 20.9448 2.22899 14.3685 2.04478C7.75529 1.84214 2.2474 7.0553 2.02635 13.6685C1.87898 18.3658 4.53161 22.7132 8.75003 24.7764C8.93424 24.8685 9.10003 24.7764 9.19214 24.629C9.22898 24.5737 9.22898 24.5369 9.22898 24.4816C9.19214 23.7264 9.22898 22.9527 9.37635 22.2343C9.52372 21.5711 10.1316 19.0658 10.5185 17.4079C10.7027 16.5974 10.7211 15.7685 10.5737 14.9579C10.5185 14.6632 10.4816 14.3685 10.4816 14.0369C10.4816 12.2685 11.4948 10.9606 12.7842 10.9606C13.8527 10.9606 14.4053 11.7711 14.4053 12.7474C14.4053 13.8527 13.7237 15.4737 13.3553 17.0027C13.1158 17.9974 13.7053 19.0106 14.7 19.25C14.8842 19.3053 15.05 19.3053 15.2342 19.3053C17.5 19.3053 19.25 16.9106 19.25 13.4658C19.25 10.4079 17.0579 8.28951 13.9263 8.28951C10.2974 8.28951 8.17898 11.0158 8.17898 13.8158C8.17898 14.8658 8.51056 15.879 9.13687 16.7264C9.22898 16.8185 9.2474 16.9658 9.22898 17.0764C9.13687 17.4632 8.93424 18.329 8.87898 18.5132C8.82372 18.7527 8.69477 18.7895 8.4553 18.6974C6.87108 17.8869 5.85793 15.5474 5.85793 13.7053C5.85793 9.68951 8.76845 6.02372 14.2579 6.02372C18.679 6.02372 22.1053 9.17372 22.1053 13.3553C22.1053 17.7579 19.3606 21.2764 15.4921 21.2764C14.5711 21.2764 13.6316 20.9264 12.95 20.2816C12.8395 20.1711 12.6185 20.1711 12.5079 20.2816C12.4711 20.3185 12.4527 20.3737 12.4158 20.429C12.2132 21.1843 11.8816 22.4369 11.7895 22.8237C11.55 23.6343 11.2185 24.3711 10.7948 25.1264C10.7027 25.2737 10.7579 25.4764 10.9421 25.5685C10.979 25.5685 10.9974 25.6053 11.0342 25.6053C12.029 25.8448 13.0606 25.9921 14.0921 25.9553C20.4106 25.9 25.7895 20.6316 25.9737 14.35Z" fill="#1C1C1C"/>
                          </svg>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {site_settings?.trustedshop_enabled == 1 && (
          <Trustbadge shopId="X8BEC543A1A07D4214B91255D1AC72EF6" />
        )}
      </div>
    </footer>
  );
}

export default Footer;
